<template>
  <transition name="fade">
    <div
      v-if="serverErrors"
      class="mb-4 rounded-lg border border-solid border-brand/30 bg-brand/5 px-4 py-3"
    >
      <ul class="flex flex-col gap-1">
        <li
          v-for="error in serverErrors"
          :key="error.source"
          class="font-sans text-base leading-snug text-brand"
        >
          {{ error.detail || error }}
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    serverErrors: {
      type: Array,
      default: null
    }
  }
}
</script>
